import React from 'react'
import AddPhotoAlternateOutlinedIcon from '@mui/icons-material/AddPhotoAlternateOutlined'
import NoteAddOutlinedIcon from '@mui/icons-material/NoteAddOutlined'
import { styled, Typography } from '@mui/material'

import { mainButtonStyle } from 'common/styles'

import { UploadWrapperProps } from '../common/commonInterfaces'

type ButtonUploadMobProps = Omit<UploadWrapperProps, 'onChange'>

const ButtonStyled = styled('label')(({ theme }) => ({
  '&': {
    ...mainButtonStyle.container,
  },
  width: '100%',
  height: '40px',
  marginTop: '24px',
  border: `1px solid ${theme.palette.primary.main}`,
  color: theme.palette.primary.main,
  borderRadius: '8px',
  '& p': {
    marginLeft: '4px',
    fontSize: '14px',
    fontWeight: 500,
  },
}))

export default function ButtonUploadMob({ name, withImage }: ButtonUploadMobProps): JSX.Element {
  return (
    <ButtonStyled htmlFor={name}>
      {withImage! ? <AddPhotoAlternateOutlinedIcon /> : <NoteAddOutlinedIcon />}
      <Typography>
        Add&nbsp;
        {withImage! ? 'photos' : 'files'}
      </Typography>
    </ButtonStyled>
  )
}
